import styled from '@emotion/styled';

export const SFormContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  column-gap: 28px;
  row-gap: 4px;

  .custom-ant-form-item {
    width: calc(50% - 14px);
  }
`;

export const SFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SSection = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  background-color: #f5f5f5;
`;

export const STitle = styled.span`
  padding-left: 16px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
`;
